import * as React from "react";
import { VisualSearchProviders } from "src/share/types/visualSearch";

const ProviderSelector= ({ onModalToggle, onProviderChange }) => {
  return (
    <div className="modal-card visual-search__provider-modal">
      <h1>
        Reverse Image Search Engines:
      </h1>
      <ul className="provider-list">
        <li className="provider-item" onClick={() => onProviderChange(VisualSearchProviders.PIMEYES)}>
          <div className="logo-container">
            <img src="/static/media/pimeyes.46ae2a4e.jpg" alt="PimEyes Logo"/>
          </div>
          <div className="provider-description">
            <p>
              Search by face image and find similar people with information where those people appear online. PimEyes analyzes millions websites to provide the most accurate search results.
            </p>
            <span className="fa fa-long-arrow-right" aria-hidden="true" /> 
          </div>
        </li>
        <li className="provider-item" onClick={() => onProviderChange(VisualSearchProviders.BING)}>
          <div className="logo-container">
            <img src="/static/media/bing.ce94bc5f.png" alt="Bing Logo"/>
          </div>
          <div className="provider-description">
            <p>
              The Bing Visual Search API returns insights for an image. Insights are visually similar images, shopping sources, webpages that include the image, and more.
            </p>
            <span className="fa fa-long-arrow-right" aria-hidden="true" />
          </div>
        </li>
        <li className="provider-item" onClick={() => onProviderChange(VisualSearchProviders.TINEYE)}>
          <div className="logo-container">
            <img src="/static/media/tineye.c7f4a94b.png" alt="TinEye Logo"/>
          </div>
          <div className="provider-description">
            <p>
              The TinEye API provides a programmatic interface to search and retrieve results from an index of billions of images. 
              Search results contain all the information given for searches done through TinEye reverse image search.
            </p>
            <span className="fa fa-long-arrow-right" aria-hidden="true" />
          </div>
        </li>
      </ul>
      <div className="actions-container">
        <button className="btn-outline" onClick={onModalToggle}>Cancel</button>
      </div>
    </div>
  )
}

export default React.memo(ProviderSelector)
